import localSettings from "./localSettings";
import prodSettings from "./prodSettings";
import devSettings from "./devSetting";
import localServer from "./localServer";
// import localServerSettings from "./localServerSettings"; //Utilizzare quando bisogna fare test
// import testBadilIt from "./testBadilIt";

const settings = prodSettings;
export default settings;
